import React from 'react'
import { createRoot } from 'react-dom/client'
import calculatorData from './state/calculatorData'
import InputMoney from './views/InputMoney'
import InputTerms from './views/InputTerms'


const CalculatedResults = ({ results, error }) => {

	let location = new URLSearchParams(window.location.search).get('location')

	return (
		<table className='table table-light table-striped'>
			<thead>
				<tr>
					<th scope='col'>Credit Score</th>
					<th scope='col'>Annual Percentage Rate</th>
					<th scope='col'>Monthly Payment</th>
				</tr>
			</thead>
			<tbody>
				{results.length > 0 && !error ? (
					results.map((r) => (
						<tr key={r.credit_range}>
							<td>{r.credit_range}</td>
							<td className='text-success'>
								<strong>{r.interest_rate}</strong>
							</td>
							<td className='text-success'>
								<strong>{r.regular_payment}</strong>
							</td>
						</tr>
					))
				) : (
					<tr>
						<td colSpan='3'>
							<i>{error || 'No offers available'}</i>
						</td>
					</tr>
				)}
			</tbody>
		</table>
	)
}


function App() {
	const { loanPurposeId, principal, termMonths, error, calculatedResults, onChange } =
		calculatorData(location)

	return (
		<>
			<div className='row'>
				<div className='col-sm-6'>
					<InputMoney
						name='principal'
						value={principal}
						onChange={onChange}
						style={{fontSize: 15}}
					/>
				</div>
				<div className='col-sm-6'>
					<InputTerms
						name='termMonths'
						loanPurposeId={loanPurposeId}
						value={termMonths}
						onChange={onChange}
						style={{fontSize: 15}}
					/>
				</div>
			</div>
			<div className='row pt-2' style={{fontSize: 15}}>
				<div className='col-sm-12'>
					{error && (
						<div className='pb-4 pt-2 text-light'>
							<i className='bi bi-exclamation-circle' /> {error}
						</div>
					)}
					<CalculatedResults results={calculatedResults} />
				</div>
			</div>
		</>
	)
}

const container = document.querySelector('#calculator_custom')
const root = createRoot(container)
root.render(<App />)
